import { queryGenerator } from "../../hooks/queries/queries";

import { getAllDepartments } from "./services";

export const useGetAllDepartments = queryGenerator(getAllDepartments);
